var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01748 5.46937C4.89327 5.59436 4.72483 5.66457 4.5492 5.66457C4.37357 5.66457 4.20513 5.59436 4.08092 5.46937L0.334042 1.69804C0.270781 1.63654 0.220322 1.56298 0.18561 1.48164C0.150897 1.40031 0.132625 1.31283 0.131861 1.22431C0.131097 1.13579 0.147855 1.048 0.181159 0.966072C0.214462 0.884142 0.263643 0.809707 0.325832 0.747111C0.388021 0.684516 0.461973 0.635014 0.543373 0.601494C0.624773 0.567973 0.71199 0.551105 0.799935 0.551875C0.887881 0.552644 0.974794 0.571035 1.0556 0.605974C1.13641 0.640913 1.2095 0.691701 1.2706 0.755375L4.5492 4.05537L7.8278 0.755375C7.95272 0.633936 8.12003 0.56674 8.29369 0.568259C8.46736 0.569778 8.63348 0.63989 8.75629 0.763495C8.87909 0.887101 8.94875 1.05431 8.95026 1.22911C8.95177 1.40391 8.88501 1.57231 8.76436 1.69804L5.01748 5.46937Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.550e01d8f8916f03466b0d9feb471afc.svg";
export { ForwardRef as ReactComponent };